import { QuoteValidationPayload } from '@shared/generated/graphql';
import { Quote } from '@shared/types/quote';
import { useEffect, useState } from 'react';
import { useComputeRates } from './useComputeRates';

export const useAutoFetchRates = ({
  validation,
  quote,
}: {
  validation?: QuoteValidationPayload;
  quote: Quote;
}) => {
  const { compute, loading } = useComputeRates();
  const [shouldAutoFetchRates, setShouldAutoFetchRates] = useState(true);
  const [originatorId, setOriginatorId] = useState<string | undefined>(
    quote.originator?.id
  );

  // NOTE(parlato): Fetch when an invalid quote is updated to valid.
  useEffect(() => {
    const quoteCarrierRateId = quote.carrierRate?.id;
    const quoteCustomerRateId = quote.customerRate?.id;
    const hasNoRates = !quoteCarrierRateId && !quoteCustomerRateId;

    if (!loading && validation?.valid && hasNoRates && shouldAutoFetchRates) {
      compute(quote.id);
      setShouldAutoFetchRates(false);
    }
  }, [validation?.valid, shouldAutoFetchRates]);

  // NOTE(parlato): Fetch when originator ID changes, with valid quote
  // that we'e not fetched for yet.
  useEffect(() => {
    if (quote.originator?.id !== originatorId) {
      setOriginatorId(quote.originator?.id);

      if (validation?.valid && shouldAutoFetchRates) {
        compute(quote.id);
        setShouldAutoFetchRates(false);
      }
    }
  }, [quote.originator?.id, originatorId]);
};
